
export default "/assets/code-bracket-mini.215dcdf1.svg"